import React from 'react';
import '../../../styles/components/_loading.scss';

type Props = {
  message?: React.ReactNode;
  fullHeight?: boolean;
  className?: string;
};

const LoadingSpinner: React.FC<Props> = ({ message, fullHeight = false, className }) => {
  const classes = ['loading-container'];
  if (fullHeight) { classes.push('loading--full'); }
  if (className) { classes.push(className); }
  return (
    <div className={classes.join(' ')}>
      <div className="loading__spinner" aria-hidden="true"></div>
      {message && <div className="loading__text">{message}</div>}
    </div>
  );
};

export default LoadingSpinner;
